import { getProductNameSelector } from './selectors';
import { useState } from 'react';
import { EnumProductType } from 'src/types/common/product';
import { NEW } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { store } from 'src/store';
export const getProductName = (
  hasModified,
  loaded,
  uuid,
  reducerType,
  productType,
  { getI18n },
) => {
  const _newTitle = {
    [EnumProductType.Set]: getI18n('allProducts.allProductslist.addProductSet'),
    [EnumProductType.Simple]: getI18n(
      'allProducts.allProductslist.addSimpleProduct',
    ),
    [EnumProductType.Variant]: getI18n(
      'allProducts.allProductslist.addVariantProduct',
    ),
  }[productType];
  const _isNew = uuid === NEW;

  const [title, setTitle] = useState(_isNew ? _newTitle : '');
  useAfterDidMountEffect(() => {
    const _s = store.getState();
    const _pName = getProductNameSelector(reducerType)(_s);
    const pageTitle = _isNew ? _newTitle : _pName;

    if (!hasModified) setTitle(pageTitle);
  }, [loaded, _isNew, hasModified, uuid]);

  return title;
};
